import { execOnLoad } from '@general/helpers';
import { openMinicart } from '@components/minicart';
import { getWishlist, deleteFromWishlist } from '@components/wishlist';

import './wishlist.scss';
import { addItemToCart } from '@services/cart';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initWishlist = async (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const productsContainer = sectionContainer.querySelector(
    '.wishlist__products-list',
  );
  if (!productsContainer) return;

  const renderWishlistProducts = async () => {
    const wishlist = await getWishlist();

    if (wishlist.listcontents.length != 0) {
      const template = sectionContainer.querySelector(
        '[data-wishlist-template]',
      );
      if (!template) return;

      wishlist?.listcontents?.forEach(async (content) => {
        const clonedTemplate = template.cloneNode(true);

        clonedTemplate.classList.remove('hidden');

        const img = clonedTemplate.querySelector('a.product-tile__gallery img');
        if (content?.iu && img) {
          img.closest('.product-tile__gallery').href = content.du;
          img.src = content.iu;
        }

        const wishListBtn = clonedTemplate.querySelector('[data-wishlist-btn]');
        if (wishListBtn) {
          if (content?.epi && wishListBtn?.dataset?.wishlistVariantId)
            wishListBtn.dataset.wishlistVariantId = content.epi;
          if (content?.empi && wishListBtn?.dataset?.wishlistProductId)
            wishListBtn.dataset.wishlistProductId = content.empi;
          if (content?.du && wishListBtn?.dataset?.wishlistProductUrl)
            wishListBtn.dataset.wishlistProductUrl = content.du;

          if (content?.epi && content?.empi && content?.du) {
            wishListBtn.addEventListener('click', async (e) => {
              e.preventDefault();
              clonedTemplate.classList.add('loading');
              wishListBtn.classList.add('loading');
              wishListBtn.dataset.wishlistStatus = 'inactive';
              await deleteFromWishlist({
                variantID: content.epi,
                masterID: content.empi,
                productURL: content.du,
              });
              clonedTemplate.remove();
            });
          }
        }

        const quickBuy = clonedTemplate.querySelector(
          '.product-tile__quick-buy',
        );
        if (quickBuy && content?.epi) {
          quickBuy.querySelector('button').disabled = false;
          quickBuy.addEventListener('click', async (e) => {
            e.preventDefault();
            addItemToCart({
              id: content.epi,
              quantity: 1,
              callbacks: {
                afterFetch: () => {
                  openMinicart(true);
                },
              },
            });
          });
        }

        const vendor = clonedTemplate.querySelector('.product-tile__vendor');
        if (vendor && content?.bt) vendor.textContent = content.bt;

        const title = clonedTemplate.querySelector('.product-tile__title p');
        if (title && content?.dt) title.textContent = content.dt;

        const compare_at_price = clonedTemplate.querySelector(
          '[data-compare-at-price]',
        );
        if (compare_at_price && content?.cprops?.compare_at_price)
          compare_at_price.textContent = content.cprops.compare_at_price;

        const price = clonedTemplate.querySelector('[data-price]');
        if (price && content?.cprops?.price)
          price.textContent = content.cprops.price;

        productsContainer.classList.remove('hidden');

        productsContainer.appendChild(clonedTemplate);
      });
    } else {
      const emptyWishlist = sectionContainer.querySelector(
        '[data-wishlist-empty]',
      );

      if (emptyWishlist) emptyWishlist.classList.remove('hidden');
    }
  };

  if (!window.SwymCallbacks) window.SwymCallbacks = [];
  window.SwymCallbacks.push(renderWishlistProducts);
};

execOnLoad(window.dAgency.initWishlist, '.wishlist__section');
